<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.75l-2.7,4.64l-5.32-0.78l1.95,5.01l-3.93,3.67l5.13,1.6l0.42,5.36l4.45-3.01l4.45,3.01l0.42-5.36l5.13-1.6
	l-3.93-3.67l1.95-5.01L3.2,787.4L0.5,782.75z M0.5,786.46l1.72,2.96l3.39-0.5l-1.24,3.2l2.5,2.34l-3.27,1.02l-0.26,3.42l-2.84-1.93
	l-2.84,1.93l-0.26-3.42l-3.28-1.02l2.51-2.34l-1.25-3.2l3.39,0.5L0.5,786.46z M2.37,793.01L2.37,793.01c0-1.03-0.84-1.87-1.87-1.87
	l0,0c-1.03,0-1.87,0.84-1.87,1.87l0,0c0,1.03,0.84,1.87,1.87,1.87l0,0C1.53,794.87,2.37,794.04,2.37,793.01L2.37,793.01z"/>
</svg>

</template>